import { Button, DatePicker, Divider, Form, Modal, Select } from "antd";
import { useForm } from "antd/lib/form/Form";
import { useMemo, useState } from "react";
import { DATE_FORMAT_MMDDYYYY, DateUtils } from "utils/dateutils";
import { Moment } from "moment";
import { SidepanelStyles } from "constants/index";
import Separator from "../../../components/date-range-picker/separator";

const { RangePicker } = DatePicker;

export type TDateRangeActivity = {
  startDate: Moment | null;
  endDate: Moment | null;
};

const getWeekDateRange = (weekNumber: number) => {
  const initDayOfWeek = DateUtils.dateTimeObj().startOf("w");

  const startDayOfWeek = DateUtils.dateTimeObj(initDayOfWeek).add(
    weekNumber,
    "w"
  );
  const endDateOfWeek = DateUtils.dateTimeObj(startDayOfWeek).endOf("w");

  return [startDayOfWeek, endDateOfWeek];
};

function ActivitiesFilterForm({
  open,
  onFinish,
  onCancel,
  onBack,
  closable
}: {
  open: boolean;
  closable: boolean;
  onFinish: (dates: TDateRangeActivity) => void;
  onBack: (e: any) => void;
  onCancel: any;
}) {
  const [form] = useForm();
  const filterValue = Form.useWatch("filter", form);
  const todayDate = DateUtils.dateTimeObj().startOf("day");

  const dateAfter5WeekDate = getWeekDateRange(5);

  const dateAfter6WeekDate = getWeekDateRange(6);

  const [dateRange, setDateRange] = useState<any>();

  const filterOptions = useMemo(() => {
    return [
      {
        value: 1,
        label: "5-week Lookahead​"
      },
      {
        value: 2,
        label: "6-week Lookahead"
      },
      { value: 3, label: "Custom Date Range" }
    ];
  }, []);

  const resetFormState = () => {
    setDateRange(undefined);
    form.resetFields();
  };

  return (
    <Modal
      className="custom-drawer"
      title="Schedule Lookahead Report"
      width={420}
      style={SidepanelStyles.style}
      data-testid="schedule-activities-filter-modal"
      footer={
        <div className="flex w-full justify-end space-x-4">
          {!closable && (
            <Button
              form="ScheduleLookaheadReportForm"
              htmlType="reset"
              className="px-5"
              onClick={onBack}
              data-testid="schedule-activities-back"
            >
              Back
            </Button>
          )}
          {closable && (
            <Button
              form="ScheduleLookaheadReportForm"
              htmlType="reset"
              className="px-5"
              onClick={onCancel}
              data-testid="schedule-activities-close"
            >
              Close
            </Button>
          )}
          <Button
            form="ScheduleLookaheadReportForm"
            htmlType="reset"
            className="px-5"
            onClick={resetFormState}
            data-testid="schedule-activities-reset"
          >
            Reset
          </Button>
          <Button
            form="ScheduleLookaheadReportForm"
            type="primary"
            htmlType="submit"
            className="px-5"
            disabled={!dateRange}
            data-testid="schedule-activities-run"
          >
            Run Report
          </Button>
        </div>
      }
      open={open}
      closable={closable}
      onCancel={onCancel}
      destroyOnClose
      maskClosable={false}
      keyboard={false}
    >
      <div className="px-3 -mt-4">
        <Form
          id="ScheduleLookaheadReportForm"
          form={form}
          layout="vertical"
          className=""
          onFinish={() => {
            onFinish({
              startDate: dateRange[0],
              endDate: dateRange[1]
            });
          }}
        >
          <div className="py-3">
            <Form.Item name="filter" label="Activity Date Range" required>
              <Select
                options={filterOptions}
                data-testid="schedule-activities-filter"
                onSelect={(v: any) => {
                  switch (v) {
                    case 1:
                      setDateRange(dateAfter5WeekDate);
                      break;
                    case 2:
                      setDateRange(dateAfter6WeekDate);
                      break;
                    case 3:
                      setDateRange(undefined);
                      break;
                    default:
                      break;
                  }
                }}
              />
            </Form.Item>

            {filterValue && (
              <RangePicker
                separator={Separator()}
                className="w-full"
                format={DATE_FORMAT_MMDDYYYY}
                disabled={filterValue !== 3}
                disabledDate={(date) => date.diff(todayDate) < 0}
                value={dateRange}
                data-testid="schedule-activities-date-range"
                onChange={(dates) => {
                  form.setFieldValue("filter", 3);
                  setDateRange(dates);
                }}
                placement="bottomLeft"
                bordered
              />
            )}
          </div>

          <Divider className="mx-0 mt-1 mb-4" />
        </Form>
      </div>
    </Modal>
  );
}
export default ActivitiesFilterForm;
